import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import Box, { IBoxProps } from '@gik/ui/Box';
import { StartInkindContent } from '@gik/marketing';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';

export interface IStartInkindBoxProps extends IBoxProps {
  trackingId?: CreateClickedLocation;
}

export const StartInkindCardBlockName = 'start-inkind-card';

export default function StartInkindCard({
  className,
  variant = 'white',
  trackingId,
  ...otherProps
}: IStartInkindBoxProps): React.ReactElement {
  const bem = bemBlock(StartInkindCardBlockName);
  const blockClasses = bem(null, null, className);

  return (
    <Box decoration="foliage-small-green" className={blockClasses} variant={variant} padded {...otherProps}>
      <div className="tw-text-center">
        <span className="tw-font-bold tw-text-xl tw-leading-none tw-block tw-mb-6">
          Ease someone&apos;s life a little.
        </span>
        <StartInkindContent trackingId={trackingId} />
      </div>
    </Box>
  );
}
